export default {
  autoCompleteAddress: ({ commit }, payload) => {
    commit('AUTO_COMPLETE_ADDRESS', { ...payload });
    return {...payload}
  },
  setAddress: ({ commit }, payload) => commit('SET_ADDRESS', payload),

  parseAddress: ({ commit }, payload) => {
    const { address } = payload.data.talent[0];

    if (address === null) return payload;

    const commitPayload = {
      id: address.id,
      uf: address.state,
      cep: address.postalcode,
      pais: address.country,
      numero: address.address_number,
      bairro: address.address_neighborhood,
      talent_id: address.talent_id,
      localidade: address.city,
      logradouro: address.address,
      complemento: address.address_complement,
      autocomplete: address.autocomplete
    }
    commit('PARSE_ADDRESS', commitPayload);
    return payload;
  },

  clearAddressState: ({ commit }) => commit('CLEAR_ADDRESS_STATE'),

  store: ({ commit }, payload) => commit('store', payload),
}